import { Directive } from '@angular/core';

@Directive({
  selector: '[rxSelectOption]',
})
export class RxSelectOptionDirective {
  constructor() {}
}
